module.exports = __webpack_public_path__ + "static/media/prompt-eng.ec41722d.png";